import React, { Component, Fragment } from 'react';
import { Form, Grid, Button } from 'semantic-ui-react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { changeReleaseCategories } from '../../state/hub/actions';
import { SelectField, TextAreaField } from 'Common/SemanticWrapper';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { APPLICATION_HUB_APP_INFO_FORM_NAME } from 'Common/FormEnum';
import { getCalculatedFamilySize } from '../../helpers/Helpers';
import { TitledCard } from 'Components';

class AppInformationForm extends Component {
  verificationOptions = [
    { key: '0', text: 'None', value: '0' },
    { key: '1', text: 'Manual', value: 'M' },
    { key: '2', text: 'Excluded', value: 'X' },
  ];

  familySizeOptions = () => {
    let options = [];
    for (
      var i = getCalculatedFamilySize(this.props.tempApplication);
      i < 100;
      i++
    ) {
      options.push({ key: i, text: `${i}`, value: i });
    }

    return options;
  };

  getReleaseCategoryButtons() {
    return {
      key: -1,
      disabled: true,
      text: (
        <Fragment>
          <Button
            size="mini"
            onClick={e => {
              this.props.dispatch(
                this.props.changeReleaseCategories(
                  this.props.releaseCategoryLookup.map(({ value }) => value)
                )
              );
            }}
          >
            Select All
          </Button>
          <Button
            size="mini"
            onClick={e => {
              this.props.dispatch(this.props.changeReleaseCategories([]));
            }}
          >
            Select None
          </Button>
        </Fragment>
      ),
    };
  }

  render() {
    const { hadNote, isReadOnly } = this.props;

    return (
      <TitledCard title={'Application Information'}>
        <Form>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  component={TextAreaField}
                  disabled={hadNote || isReadOnly}
                  label={'Notes'}
                  maxLength={250}
                  name={Fields.Notes}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  component={SelectField}
                  label={'Release Category'}
                  name={Fields.ReleaseMapping}
                  options={[
                    this.getReleaseCategoryButtons(),
                    ...this.props.releaseCategoryLookup,
                  ]}
                  multiple
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={8}>
                <Field
                  component={SelectField}
                  label={'Special Verification'}
                  name={Fields.VerificationStatus}
                  options={this.verificationOptions}
                  disabled={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <Field
                  component={SelectField}
                  label={'Household Size'}
                  maxLength={2}
                  name={Fields.FamilySize}
                  options={this.familySizeOptions()}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </TitledCard>
    );
  }
}

const validate = values => {
  const errors = {};

  if (values[Fields.FamilySize] <= 0) {
    errors[Fields.FamilySize] = 'Household Size should be between 1 and 99';
  }

  return errors;
};

AppInformationForm = reduxForm({
  validate,
  form: APPLICATION_HUB_APP_INFO_FORM_NAME,
  destroyOnUnmount: true,
})(AppInformationForm);

const selector = formValueSelector(APPLICATION_HUB_APP_INFO_FORM_NAME);
AppInformationForm = withRouter(
  connect(state => {
    const releaseCategoryValues = selector(state, Fields.ReleaseMapping);
    return {
      releaseCategoryValues,
      changeReleaseCategories,
    };
  })(AppInformationForm)
);

export { AppInformationForm };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/AppInformationForm.js